export default "__VITE_ASSET__Cs7id8XU__"